class ProductSidebar {
  constructor(element) {
    this.element = element;
    this.mediaQuery = window.matchMedia("screen and (min-width: 990px)");
    this.selectors = {
      id: `.js-targeted-part`,
      section: ".js-section-product",
      innerWrapper: ".js-sticky",
    };
    this.headerHeight = 59;
    this.mainProductTopPadding = 55;
    this.bottomPosition = 30;

    this.handleResize = this.handleResize.bind(this);
    this.initIfNeeded();
    this.mediaQuery.addEventListener("change", this.handleResize);
  }

  initIfNeeded() {
    if (this.element.hasAttribute("data-disable-sticky")) return;
    if (this.mediaQuery.matches) {
      this.init();
    } else {
      this.handleStickyMobile();
    }
  }

  updateMaxHeight() {
    if (!this.inner) return;

    const totalSpacing = this.headerHeight + this.mainProductTopPadding + this.bottomPosition;
    this.maxHeight = window.innerHeight - totalSpacing
    this.inner.style.setProperty('--max-height', `${this.maxHeight}px`);
  }

  init() {
    this.sidebar = new StickySidebar(this.selectors.id, {
      containerSelector: this.selectors.section,
      innerWrapperSelector: this.selectors.innerWrapper,
      topSpacing: this.headerHeight + this.mainProductTopPadding,
      bottomSpacing: this.bottomPosition,
    });

    this.inner = this.element.querySelector(this.selectors.innerWrapper);

    if (this.inner && !this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.inner.classList.toggle('is-overflowing', this.inner.scrollHeight > this.maxHeight)
      });
      this.resizeObserver.observe(this.inner);
    }

    this.element.classList.remove("is-disabled");

    this.updateMaxHeight();
  }

  destroy() {
    if (this.sidebar) {
      this.sidebar.destroy();
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.inner) {
      this.inner.style.removeProperty('--max-height');
      this.inner.classList.remove('is-overflowing');
    }

    this.element.classList.add("is-disabled");
  }

  handleStickyMobile() {
    const footer = this.element.querySelector('.form__foot');
    if (!footer) return;

    const container = this.element;
    const footerHeight = footer.offsetHeight;

    // Ensure container has padding so footer doesn't cover content
    container.style.paddingBottom = footerHeight + 'px';
    container.style.position = 'relative';

    const update = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const containerTop = window.scrollY + container.getBoundingClientRect().top;
      const containerBottom = containerTop + container.offsetHeight;

      const isFixed = scrollY + window.innerHeight < containerBottom && scrollY + window.innerHeight > containerTop + footerHeight;
      footer.classList.toggle('is-fixed', isFixed);
    }

    window.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    update();

    const interval = setInterval(update, 50);
    setTimeout(() => clearInterval(interval), 500);
  }

  handleResize() {
    if (!this.mediaQuery.matches) {
      // Destroy on mobile
      this.destroy();
      return;
    } else {
      this.handleStickyMobile();
    }

    this.updateMaxHeight();

    if (this.sidebar) {
      // Update sidebar if it exists
      requestAnimationFrame(() => {
        this.sidebar.updateSticky();
      });
    } else {
      // Initialize sidebar
      this.init();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const target = document.querySelector(".js-targeted-part");
  if (!target) return;

  new ProductSidebar(target);
});
